import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation } from '@tanstack/react-query'
 
export const useCreateStripeOnboardingSessionMutation = () => {
  return useMutation({
    mutationKey: ['user', 'stripeOnboardAccount'],
    mutationFn: async (params: {StripeAccountId:string}) => {return await makeApiRequest({
        url: `/Stripe_Payout/stripeStartSession`,
        method: 'POST',
        data: {
          ...params,
        },
        isAuthenticated: true,
        fallbackError: 'noFallback',
        isV3Api: true,
      })
    },
    onSuccess(data) {
      return data
    },
  })
}
